import * as Yup from "yup";

export const deliveryInfoDetailValidationSchema = Yup.object({
  order_line: Yup.array().of(
    Yup.object().shape({
      id: Yup.number(),
      product_name: Yup.string(),
      product_uom_qty: Yup.number().required("Must Be greater Than 0"),
      qty_done: Yup.number()
        .min(0, "Must be a positive number")
        .max(Yup.ref("product_uom_qty"), "Must be less then Demand")
        .required("PriDone Quantity is required"),
        
    })
  ),
});
